import { useCallback } from 'react';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { Heading, Text } from 'react-aria-components';
import { z } from 'zod';
import Button from 'src/components/ui/Button';
import LinkButton from 'src/components/ui/LinkButton';

const EmailCheckPage = () => {
  const navigate = useNavigate();
  const { email, from } = Route.useSearch();

  const onBack = useCallback(async () => {
    if (localStorage.getItem('clientId') && localStorage.getItem('authToken')) {
      window.location.reload();
    } else
      await navigate({
        to: from === 'creator-login' ? '/creator-login' : '/login',
        replace: true,
      });
  }, [navigate, from]);

  return (
    <div className="w-full max-w-[26.75rem] mx-auto text-center p-11">
      <Heading level={2} className="text-surface-alt-90 text-4xl font-bold">
        Check your Email
      </Heading>
      <Text
        elementType="p"
        className="text-sm text-surface-alt-75 font-normal my-4"
      >
        We sent an authentication link to{' '}
        <strong className="text-surface-alt-90">{email}</strong>
      </Text>
      <Button
        onPress={() =>
          navigate({ to: '/otp-login', search: { email }, replace: true })
        }
      >
        Use One-time Password
      </Button>
      <Text
        elementType="span"
        className="block text-surface-alt-75 font-medium my-1"
      >
        or
      </Text>
      <LinkButton reversed onPress={onBack}>
        Back to Sign In
      </LinkButton>
    </div>
  );
};

const MagicSchema = z.object({
  email: z.string().email(),
  // The sign-in page to go back to; anything else falls back to `/login`.
  from: z.enum(['creator-login']).optional().catch(undefined),
});

export const Route = createFileRoute('/_auth/magic-link')({
  validateSearch: (search) => MagicSchema.parse(search),
  beforeLoad: async ({ search }) => {
    const { success } = MagicSchema.safeParse(search);

    if (!success) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/login',
      });
    }
  },
  component: EmailCheckPage,
});
